import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, Plane, Wifi } from "lucide-react";

export default function JobCard({ job, index = 0 }) {
  return (
    <Link
      to={`/jobs/${job.id}`}
      data-testid={`job-card-${job.id}`}
      className="group relative block bg-white border border-[#DCD7C9] p-6 sm:p-8 transition-all hover:-translate-y-0.5 hover:border-[#1A2E24]"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex flex-wrap gap-2 mb-3">
            <span className="text-[10px] uppercase tracking-[0.2em] font-semibold bg-[#1A2E24]/10 text-[#1A2E24] px-2.5 py-1">
              {job.category}
            </span>
            <span className="text-[10px] uppercase tracking-[0.2em] font-semibold bg-[#D35400]/10 text-[#D35400] px-2.5 py-1">
              {job.job_type}
            </span>
            {job.visa_sponsorship && (
              <span className="text-[10px] uppercase tracking-[0.2em] font-semibold bg-[#2E4E3F]/10 text-[#2E4E3F] px-2.5 py-1">
                Visa Sponsored
              </span>
            )}
          </div>
          <h3 className="font-display text-xl sm:text-2xl font-medium text-[#1A2E24] group-hover:text-[#D35400] transition-colors">
            {job.title}
          </h3>
          <p className="mt-2 text-sm text-[#5C6B64] line-clamp-2">{job.description}</p>
        </div>
        <div className="font-display text-2xl text-[#DCD7C9] font-semibold hidden sm:block">
          {String(index + 1).padStart(2, "0")}
        </div>
      </div>
      <div className="mt-6 pt-6 border-t border-[#DCD7C9] grid grid-cols-2 sm:grid-cols-4 gap-4 text-xs text-[#5C6B64]">
        <div className="flex items-center gap-2"><MapPin size={14} />{job.location}</div>
        <div className="flex items-center gap-2"><Briefcase size={14} />{job.salary_range}</div>
        <div className="flex items-center gap-2"><Plane size={14} />{job.visa_sponsorship ? "H-1B/O-1" : "No sponsor"}</div>
        <div className="flex items-center gap-2"><Wifi size={14} />{job.remote ? "Remote OK" : "On-site"}</div>
      </div>
    </Link>
  );
}
